// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3GBMA","question":"Question_question__KyQnm","description":"Question_description__3UZKc"};